/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Типы заявок на Day Off
 */
export enum DayOffApplicationType {
    PAID = 'paid',
    UNPAID = 'unpaid',
}
